$(document).ready(function() {	
	var cookie = document.cookie;
	$(".imgpopclose a").click(function(e){  
		e.preventDefault(); 
		$('.imagepopup').fadeOut(300);		
		
		if (cookie.indexOf('cookieconfirm=', 0) == -1) {
			var expiration = new Date();
			expiration.setDate(expiration.getDate()+21);
			document.cookie = 'cookieconfirm=1;expires=' + expiration + ';path=/';	
		}		
	});
	if (cookie.indexOf('cookieconfirm=', 0) == -1) 
	{
		$('.imagepopup').fadeIn(300);	
	}
	else
	{
		$('.imagepopup').fadeOut(300);
	}	

});		